module.exports = __webpack_public_path__ + "static/media/scholarship.8c8f3176.jpg";